module.exports = __webpack_public_path__ + "img/gyant_xl_light_grey_ba_list.19c40d9e.jpg";